export default __webpack_public_path__ + "static/media/no-students.841ed48e.svg";